import { render, staticRenderFns } from "./LogPayments.vue?vue&type=template&id=b184b638&"
import script from "./LogPayments.vue?vue&type=script&lang=js&"
export * from "./LogPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports